module.exports = __webpack_public_path__ + "static/img/mumi-1.5e6241d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/mumi-1.jpg
// module id = J2pS
// module chunks = 1